import React from "react"
import { Tab, Tabs } from "react-bootstrap"

import { PageTitle } from "../../config/AppSettingsConfigProvider"
import { withSampleConfig } from "../../config/SampleConfigProvider"
import SampleScheduleTab from "./SampleScheduleTab"
import SampleRoundsTab from "./SampleRoundsTab"
import UploadDataTab from "./UploadDataTab"
import ManageOfflineFilesTab from "./ManageOfflineFilesTab"
import { getFormattedMessage } from "../shared_components_registration"

const SampleManagementDash = ({ intl, isNSView = false }) => {
  const idStr = isNSView ? "ns" : "sample"
  const msgStr = isNSView ? "NS" : "Sample"
  const labelStr = `${isNSView ? "Nutrient Solution" : "Sample"} Management`
  return (
    <div className={"full-height"}>
      <div className={"content-block full-height-min"}>
        <PageTitle
          glyph={isNSView ? "tint" : "barcode"}
          id={`navigation.${idStr}ManagementOption`}
          description={labelStr}
          defaultMessage={labelStr}
        />
        <Tabs defaultActiveKey={"SampleRounds"} id={"tabs_sample_management"} className={"full-height"}>
          <Tab
            eventKey={"SampleSchedule"}
            title={getFormattedMessage(
              `samplemanagement.tab.${idStr}.schedule`,
              `${msgStr} Schedule`,
              true,
              intl,
            )}
          >
            <div className={"tab-body my_tab_body"}>
              <SampleScheduleTab intl={intl} />
            </div>
          </Tab>
          <Tab
            eventKey={"SampleRounds"}
            title={getFormattedMessage(
              `samplemanagement.tab.${idStr}.rounds`,
              `${msgStr} Rounds`,
              true,
              intl,
            )}
          >
            <div className={"tab-body my_tab_body"}>
              <SampleRoundsTab />
            </div>
          </Tab>
          <Tab
            eventKey={"UploadSampleData"}
            title={getFormattedMessage(
              `samplemanagement.tab.upload.${idStr}.data`,
              `Upload ${msgStr} Data`,
              true,
              intl,
            )}
          >
            <div className={"tab-body my_tab_body"}>
              <UploadDataTab />
            </div>
          </Tab>
          {!isNSView && (
            <Tab
              eventKey={"ExternalSampleJSON"}
              title={getFormattedMessage(
                "samplemanagement.tab.manage.offline.files",
                "Manage Offline Files",
                true,
                intl,
              )}
            >
              <div className={"tab-body my_tab_body"}>
                <ManageOfflineFilesTab />
              </div>
            </Tab>
          )}
        </Tabs>
      </div>
    </div>
  )
}

export default withSampleConfig(SampleManagementDash)
